import React from 'react';
import { Link } from 'gatsby';
import * as styles from '../styles/components/navBar.module.scss';

export interface NavBarItem {
    name: string;
    location: string;
}

export interface NavBarProps {
    navBarClassName?: string ;
    navBarItems: NavBarItem[];
}

export class NavBar extends React.Component<NavBarProps, {}> {
    public render() {
        const navItemDivider = <span>&nbsp;||&nbsp;</span>;

        const component =
            <div className={[styles.navBar, this.props.navBarClassName].join(' ')}>
                {this.props.navBarItems.map((item, i, arr) =>
                    <h2>
                        <Link to={item.location}>
                            {item.name}
                        </Link>
                        {i < arr.length - 1 ? navItemDivider : null}
                    </h2>
                )}
            </div>;
        return component;
    }
}
